/** Client wrapper around the submitVerification cloud function. */
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface SubmitVerificationArgs {
  parkingId: string;
  method: 'manual' | 'photo';
  heightM?: number;
  photoStoragePath?: string;
}

export interface SubmitVerificationResult {
  status: 'accepted' | 'pending_review';
  heightM: number;
  ocrExtractedHeightM?: number;
}

export async function submitVerification(
  args: SubmitVerificationArgs
): Promise<SubmitVerificationResult> {
  const callable = httpsCallable<SubmitVerificationArgs, SubmitVerificationResult>(
    functions,
    'submitVerification'
  );
  const res = await callable(args);
  return res.data;
}
